import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import App from './App.vue'
import store from './store'
import 'amfe-flexible'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'animate.css/animate.min.css'

import './assets/styles/main.scss';

import domtoimage from 'dom-to-image'; // 内容转图片
import QRCode from 'qrcode'; // 内容生成二维码

import html2canvas from 'html2canvas';

import * as echarts from 'echarts';
import { setupLayoutState } from './utils/layout'
import Toast from './utils/toast'; // 导入 Toast 工具

Vue.prototype.$echarts = echarts;
// 将库挂载到 Vue 原型上，这样在组件中可以通过 this.$domtoimage 和 this.$qrcode 访问
Vue.prototype.$domtoimage = domtoimage;
Vue.prototype.$qrcode = QRCode;

Vue.prototype.$html2canvas = html2canvas;

// 注册全局 Toast 方法
Vue.prototype.$toast = Toast;

Vue.use(Vuex)
Vue.use(VueAwesomeSwiper)

// 设计稿宽度 750：锁定根字号，避免 iPad 等大屏被 amfe-flexible 继续放大导致布局/图片错位。
// 与 postcss-pxtorem 的 rootValue=75 保持一致：750px => 10rem。
function lockRootFontSizeForLargeScreen() {
  const docEl = document.documentElement
  const refresh = () => {
    const w = docEl.clientWidth
    if (w >= 750) {
      docEl.style.fontSize = '75px'
    } else {
      // 交还给 amfe-flexible 的动态计算（它会监听 resize 并设置 fontSize）
      docEl.style.fontSize = ''
    }
  }
  refresh()
  window.addEventListener('resize', refresh)
}

lockRootFontSizeForLargeScreen()

// 整页等比缩放（基于 750x1334 设计稿），不允许滚动：把缩放比例写入 CSS 变量 --app-scale
function setupAppScale() {
  const DESIGN_W = 750
  const DESIGN_H = 1334
  const docEl = document.documentElement

  const refresh = () => {
    const vw = window.innerWidth
    const vh = window.innerHeight
    const scale = Math.min(vw / DESIGN_W, vh / DESIGN_H)
    docEl.style.setProperty('--app-scale', String(scale))
  }

  refresh()
  window.addEventListener('resize', refresh)
}

setupAppScale()

// 用于切换：小屏铺满 / 大屏设计稿尺寸
// （这里尽早执行，减少首屏闪烁）
setupLayoutState()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
